const spacePadding = (text: string, distLength: number): string => {
	const originalLength = text.length;
	let distText = text;
	for (let i = 0; i < distLength - originalLength; i++) {
		distText = ' ' + distText;
	}
	return distText;
};

export default spacePadding;
